import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class CreateUserResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "email": "michael@dundermifflin.com",
            },
            errors: []
        }
    }

    user() {
        return this.content().user
    }

    userEmail(){
        return this.user().email
    }
}